var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sidebar"},[_c('div',{staticClass:"index"},_vm._l((_vm.keys),function(key){return _c('a',{key:key,staticClass:"index-item",attrs:{"role":"button"},on:{"click":function($event){_vm.clickKey(key)}}},[_vm._v(_vm._s(key))])}))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-41d0f43e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/trainer/Sidebar.vue
// module id = null
// module chunks = 